"use client";

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-[2.125] w-[4.25rem] flex-shrink-0 cursor-pointer items-center rounded-full border !border-[#DEDEDE]/70 data-[state=checked]:!border-transparent transition-all focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:!bg-[#6ECB61] data-[state=unchecked]:!bg-grey200",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-[1.625rem] w-[1.625rem] rounded-full bg-white shadow-[0_3px_4px_rgba(0,0,0,.25)] ring-0 transition-transform data-[state=checked]:translate-x-[2.625rem] data-[state=unchecked]:translate-x-[.25rem]",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
